import {
  SessionAction,
  SessionActionTypes,
  SessionState,
} from "./sessionTypes";

const sessionInitialState: SessionState = {
  tokenData: undefined,
  loading: true,
  tenants: [],
  error: "",
  tenant: undefined,
  role: undefined,
  sessionRead: false,
};

export const sessionReducer = (
  state = sessionInitialState,
  action: SessionAction
): SessionState => {
  switch (action.type) {
    case SessionActionTypes.SET_SESSION:
      return {
        ...state,
        sessionRead: false,
      };
    case SessionActionTypes.READ_SESSION_SUCCESS:
      return {
        ...state,
        tokenData: {
          tokenExpiration: action.tokenExpiration,
          currentTenant: action.currentTenant,
          allowedScopes: action.scopesDetected,
        },
        role: action.role,
        tenant: action.tenant,
        sessionRead: true,
      };
    case SessionActionTypes.READ_SESSION_FAILED:
      return {
        ...state,
        sessionRead: true,
      };
    case SessionActionTypes.DELETE_SESSION:
      return {
        ...state,
        tokenData: undefined,
        loading: true,
        tenants: [],
        error: "",
        tenant: undefined,
        role: undefined,
        sessionRead: true,
      };
    default:
      return state;
  }
};
